import { FilterProps } from "@components/job_search/filters/filter_props.ts";
import useDevice from "@hooks/use_device.ts";
import { DesktopSingleSelectFilter } from "@components/job_search/filters/desktop_single_select_filter.tsx";
import { MobileSingleSelectFilter } from "@components/job_search/filters/mobile_single_select_filter.tsx";

export interface SingleSelectFilterProps extends FilterProps {
  value: string;
  onValueChange: (value: string) => void;
}

export interface SpecializedSingleSelectFilterProps extends SingleSelectFilterProps {
  buttonText: string;
}

export const SingleSelectFilter = (props: SingleSelectFilterProps) => {
  const device = useDevice();

  const selectedLabel = props.options.find((option) => option.value === props.value)?.label;

  const buttonText = selectedLabel ? `${props.name} (${selectedLabel})` : props.name;

  if (device.isMobile) {
    return <MobileSingleSelectFilter buttonText={buttonText} {...props} />;
  }

  return <DesktopSingleSelectFilter buttonText={buttonText} {...props} />;
};
